import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "../../node_modules/rxjs";

import { environment } from "../environments/environment";

import {
  TeamModel,
  ProjectModel,
  ProjectTaskModel,
  ProjectFileModel,
  ProjectCommentModel,
  ProjectListModel,
  ProjectUserModel,
  ProjectCategoryModel,
} from "./../model/CronosModel";

import _ from "lodash";

@Injectable()
export class CronosService {
  public headers: any;

  constructor(private http: HttpClient) {
    this.headers = new HttpHeaders({
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json;charset=utf-8",
    });
  }

  public listTeams(clientId: number): Observable<Array<TeamModel>> {
    return this.http.get<Array<TeamModel>>(
      environment.apiHost + "/administracao/team/list/cliente/" + clientId
    );
  }

  public getTeam(teamId: number): Observable<TeamModel> {
    return this.http.get<TeamModel>(
      environment.apiHost + "/administracao/team/" + teamId
    );
  }

  public listProjects(userId: number): Observable<Array<ProjectModel>> {
    return this.http.get<Array<ProjectModel>>(
      environment.apiHost + "/cronos/board/list/user/" + userId
    );
  }

  public findByBoardId(boardId: number): Observable<Array<ProjectListModel>> {
    return this.http.get<Array<ProjectListModel>>(
      environment.apiHost + "/cronos/list/board/" + boardId
    );
  }

  public findOverviewByBoardId(boardId: number): Observable<Array<any>> {
    return this.http
      .get<Array<any>>(
        environment.apiHost + "/cronos/list/overview/board/" + boardId
      )
      .map((response) => {
        return (response || []).map((item) => {
          if (item.task) {
            item.task = JSON.parse(item.task);
            item.task = this.mapTask(item.task);
          }
          return item;
        });
      });
  }

  public saveProject(data: ProjectModel): Observable<ProjectModel> {
    return this.http
      .post(environment.apiHost + "/cronos/board/save", JSON.stringify(data), {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveList(data: ProjectListModel): Observable<ProjectListModel> {
    var copy = _.cloneDeep(data);
    copy.tasks = this.convertTaskCategories(copy.tasks);
    return this.http
      .post(environment.apiHost + "/cronos/list/save", JSON.stringify(copy), {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public removeList(data: ProjectListModel): Observable<ProjectListModel> {
    var copy = _.cloneDeep(data);
    copy.tasks = this.convertTaskCategories(copy.tasks);
    return this.http
      .post(environment.apiHost + "/cronos/list/remove", JSON.stringify(copy), {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveTask(data): Observable<ProjectTaskModel> {
    var copy = _.assign({}, data, {
      categories: JSON.stringify(this.mapCategories(data.categories || [])),
    });
    return this.http
      .post(environment.apiHost + "/cronos/task/save", JSON.stringify(copy), {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => {
        let task = JSON.parse(response);
        if (task.categories)
          task.categories =
            typeof task.categories == "string"
              ? JSON.parse(task.categories)
              : task.categories;

        return task;
      });
  }

  public refreshPositionTasks(data): Observable<any> {
    var copyTasks = _.cloneDeep(data);
    var copy = this.mapTasksCategories(copyTasks);

    return this.http
      .post(
        environment.apiHost + "/cronos/task/refreshPosition",
        JSON.stringify(copy),
        { headers: this.headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public removeTask(data: ProjectTaskModel): Observable<ProjectTaskModel> {
    var copy = _.assign({}, data, {
      categories: JSON.stringify(this.mapCategories(data.categories || [])),
    });
    return this.http
      .post(environment.apiHost + "/cronos/task/remove", JSON.stringify(copy), {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveUserTask(data, updatedUserId): Observable<any> {
    return this.http
      .post(
        environment.apiHost + "/cronos/task/user/save/" + updatedUserId,
        JSON.stringify(data),
        { headers: this.headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public removeUserTask(data, updatedUserId): Observable<any> {
    return this.http
      .post(
        environment.apiHost + "/cronos/task/user/delete/" + updatedUserId,
        JSON.stringify(data),
        { headers: this.headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public saveCheckList(data): Observable<any> {
    let copy = _.assign({}, data, {
      checkItems: JSON.stringify(data.checkItems || []),
    });
    return this.http
      .post(
        environment.apiHost + "/cronos/task/checklist/",
        JSON.stringify(copy),
        { headers: this.headers, responseType: "text" }
      )
      .map((response) => {
        let checkList = JSON.parse(response);
        if (checkList.checkItems)
          checkList.checkItems =
            typeof checkList.checkItems == "string"
              ? JSON.parse(checkList.checkItems)
              : checkList.checkItems;

        return checkList;
      });
  }

  public removeCheckList(checkListId): Observable<any> {
    return this.http
      .delete(environment.apiHost + "/cronos/task/checklist/" + checkListId, {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveComment(
    data: ProjectCommentModel
  ): Observable<ProjectCommentModel> {
    return this.http
      .post(
        environment.apiHost + "/cronos/task/comment/save",
        JSON.stringify(data),
        { headers: this.headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public removeComment(id: number): Observable<any> {
    return this.http
      .delete(environment.apiHost + "/cronos/task/comment/" + id, {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public listCategories(
    boardId: number
  ): Observable<Array<ProjectCategoryModel>> {
    return this.http.get<Array<ProjectCategoryModel>>(
      environment.apiHost + "/cronos/category/list/board/" + boardId
    );
  }

  public saveCategory(
    model: ProjectCategoryModel
  ): Observable<ProjectCategoryModel> {
    return this.http
      .post(environment.apiHost + "/cronos/category/save", model, {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public removeCategory(id: number): Observable<any> {
    return this.http
      .delete(environment.apiHost + "/cronos/category/" + id, {
        headers: this.headers,
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public saveFile(
    fileData: File,
    model: ProjectFileModel
  ): Observable<ProjectFileModel> {
    let inputData = new FormData();
    inputData.append("file", fileData, fileData.name);
    inputData.append("model", JSON.stringify(model));
    return this.http
      .post(environment.apiHost + "/cronos/task/file/save", inputData, {
        responseType: "text",
      })
      .map((response) => JSON.parse(response));
  }

  public removeFile(model: ProjectFileModel): Observable<any> {
    return this.http.post(
      environment.apiHost + "/cronos/task/file/remove",
      model,
      { headers: this.headers, responseType: "text" }
    );
  }

  public completeProjectData(
    project: ProjectModel,
    teamInfo: TeamModel
  ): ProjectModel {
    project.lists.forEach((list) => {
      list = this.completeProjectListData(project, list, teamInfo);
    });
    return project;
  }

  public completeProjectListData(
    project: ProjectModel,
    list: ProjectListModel,
    teamInfo: TeamModel
  ): ProjectListModel {
    list.tasks.forEach((task) => {
      this.loadUserInitials(task, teamInfo);
      this.completeComments(task, teamInfo);
      this.completeChecklists(task);
    });
    return list;
  }

  public loadUserInitials(task: ProjectTaskModel, teamInfo: TeamModel) {
    task.users.forEach((user) => {
      if (teamInfo && teamInfo.usuarios) {
        const userInfo = teamInfo.usuarios.find((x) => x.id == user.userId);
        if (userInfo != null) {
          const userNames = userInfo.nome.split(" ");
          if (userNames.length > 1) {
            user.initials =
              userNames[0].substring(0, 1).toUpperCase() +
              userNames[1].substring(0, 1).toUpperCase();
          } else {
            user.initials = userInfo.nome.substring(0, 1).toUpperCase();
          }
        }
      }
    });
  }

  public completeComments(task: ProjectTaskModel, teamInfo: TeamModel) {
    task.comments = task.comments.sort((a, b) => {
      return a.registerDate > b.registerDate ? -1 : 1;
    });
    task.comments.forEach((comment) => {
      if (teamInfo && teamInfo.usuarios) {
        const userInfo = teamInfo.usuarios.find(
          (x) => x.id == comment.senderUserId
        );
        if (userInfo != null) {
          comment.senderUserName = userInfo.nome;
        }
      }
    });
  }

  public completeChecklists(task: ProjectTaskModel) {
    if (task.checkLists != null) {
      task.checkLists = task.checkLists.sort((a, b) => {
        return a.position < b.position ? -1 : 1;
      });
      task.checkListsTotalItems = 0;
      task.checkListsTotalCompleted = 0;
      task.checkLists.forEach((checklist) => {
        if (checklist.checkItems != null && checklist.checkItems.length > 0) {
          checklist.percentage =
            (checklist.checkItems.filter((x) => x.conclude == true).length /
              checklist.checkItems.length) *
            100;
          task.checkListsTotalItems += checklist.checkItems.length;
          task.checkListsTotalCompleted += checklist.checkItems.filter(
            (x) => x.conclude == true
          ).length;
        } else {
          checklist.percentage = 100;
        }
      });
    }
  }

  public listProjectUsers(
    projectId: number
  ): Observable<Array<ProjectUserModel>> {
    return this.http.get<Array<ProjectUserModel>>(
      environment.apiHost + "/cronos/task/user/list/board/" + projectId
    );
  }

  public mapTask(task) {
    task.users =
      typeof task.users == "string" ? JSON.parse(task.users) : task.users || [];
    task.checkLists = this.mapCheckLists(task.checkLists);
    task.categories =
      typeof task.categories == "string"
        ? JSON.parse(task.categories)
        : task.categories || [];
    task.comments =
      typeof task.comments == "string"
        ? JSON.parse(task.comments)
        : task.comments || [];
    task.files =
      typeof task.files == "string" ? JSON.parse(task.files) : task.files || [];
    return task;
  }

  public mapLists(listTasks): Array<any> {
    return _.chain(listTasks)
      .groupBy("id")
      .map((listTasks, key) => {
        var list = _.filter(listTasks, ["id", parseInt(key)])[0];
        return {
          boardId: list.boardId,
          clienteId: list.clienteId,
          id: list.id,
          name: list.name,
          position: list.position,
          status: list.status,
          tasks: _.orderBy(
            _.reduce(listTasks, this.mapListTasks, []),
            ["position"],
            ["asc"]
          ),
        };
      })
      .value();
  }

  public mapListTasks(tasks, listTask) {
    if (listTask.task) tasks.push(listTask.task);
    return tasks;
  }

  public mapCheckLists(checkLists) {
    checkLists =
      typeof checkLists == "string" ? JSON.parse(checkLists) : checkLists || [];
    return (checkLists || []).map((item) => {
      item.checkItems =
        typeof item.checkItems == "string"
          ? JSON.parse(item.checkItems)
          : item.checkItems || [];
      return item;
    });
  }

  public convertTaskCategories(tasks) {
    return _.map(tasks, (task) => {
      task.categories =
        typeof task.categories != "string"
          ? JSON.stringify(this.mapCategories(task.categories || []))
          : task.categories;
      return task;
    });
  }

  public mapCategories(categories) {
    return _.reduce(
      categories,
      (results, category) => {
        results.push({ id: category.id });
        return results;
      },
      []
    );
  }

  public mapTasksCategories(tasks) {
    return _.reduce(
      tasks,
      (items, task) => {
        task.categories = JSON.stringify(
          this.mapCategories(task.categories || [])
        );
        items.push(task);
        return items;
      },
      []
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/CronosService.ts